import { Panel } from "../enums";

export class User {
    firstName: string;
    lastName: string;
    email: string;
    phone: number;
    password: string;
    token?: any;
    id: number;
    role: string;
    panel: Panel;
    franchiseId;
    warehouseId;
    isAdmin: boolean;
    userPanel: Panel;
}

